import { useEffect, useState } from 'react';

import { getTimerValue, ZERO_TIMER_COUNT } from '../utils';

const TIMER_INTERVAL = 1000; // 1 sec

/**
 * Hook that calculates the remaining time until a bid expiry date.
 *
 * @param {string} [bidExpiryDateTime] - The bid expiry date and time in UTC, ISO 8601 format (e.g., "2024-08-20T09:56:59.287Z").
 *
 */
export const useBidExpiryTimer = (bidExpiryDateTime: string) => {
  const [bidExpiry, setBidExpiry] = useState(ZERO_TIMER_COUNT);

  const isBidExpired = bidExpiry === ZERO_TIMER_COUNT;

  useEffect(() => {
    let timerInterval: ReturnType<typeof setInterval> | null = null;

    if (bidExpiryDateTime) {
      timerInterval = setInterval(() => {
        const currentValue = getTimerValue(bidExpiryDateTime);

        if (currentValue === ZERO_TIMER_COUNT && timerInterval) {
          clearInterval(timerInterval);
        }
        setBidExpiry(currentValue);
      }, TIMER_INTERVAL);
    }

    return () => {
      if (timerInterval) {
        clearInterval(timerInterval);
      }
    };
  }, [bidExpiryDateTime]);

  return { bidExpiry, isBidExpired };
};
